import styles from "./HeroPage.module.scss";
import Header from "../../components/header/Header";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../../constants/routes";
import { useState } from "react";
import useWindowSize from "../../hooks/useWindowSize";

const HERO_LOGO_ICON = "https://www.figma.com/api/mcp/asset/e358365a-349b-4e2b-8355-568f75c3fb64";
const HERO_SWIPE_ICON = "https://www.figma.com/api/mcp/asset/127bd876-4b19-4ced-896f-37873e929377";
const HERO_SAVE_ICON = "https://www.figma.com/api/mcp/asset/6d8de650-de92-4a15-b8b1-5d4e6f497c2a";
const HERO_SHARE_ICON = "https://www.figma.com/api/mcp/asset/5d74e732-6062-49e0-abcf-65b643399d70";

const HeroPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { windowSize } = useWindowSize();
  const [activeFeature, setActiveFeature] = useState<number | null>(null);
  const isMobile = windowSize === "mobile";

  const startHandler = () => {
    localStorage.setItem("heroSeen", "1");
    navigate(ROUTES.FOR_YOU);
  };

  const features = [
    {
      label: t("hero_swipe"),
      desc: t("hero_swipe_desc"),
      icon: HERO_SWIPE_ICON,
      iconClassName: styles.swipeIcon,
      baseClassName: styles.swipeBase,
      accentClassName: styles.swipeAccent,
    },
    {
      label: t("hero_save"),
      desc: t("hero_save_desc"),
      icon: HERO_SAVE_ICON,
      iconClassName: styles.saveIcon,
      baseClassName: styles.saveBase,
      accentClassName: styles.saveAccent,
    },
    {
      label: t("hero_share"),
      desc: t("hero_share_desc"),
      icon: HERO_SHARE_ICON,
      iconClassName: styles.shareIcon,
      baseClassName: styles.shareBase,
      accentClassName: styles.shareAccent,
    },
  ];

  return (
    <div className={styles.wrapper}>
      <Header source="hero" className={styles.header} />

      <div className={styles.content}>
        <div className={styles.logo}>
          <img src={HERO_LOGO_ICON} alt="HiViewer" />
        </div>

        <h1 className={styles.title}>{t("hero_title")}</h1>

        <div className={styles.features}>
          {features.map((f, i) => (
            <div
              key={i}
              className={`${styles.featureItem} ${activeFeature === i ? styles.featureItemActive : ""}`}
              {...(isMobile
                ? { onClick: () => setActiveFeature(activeFeature === i ? null : i) }
                : { onMouseEnter: () => setActiveFeature(i), onMouseLeave: () => setActiveFeature(null) })}
            >
              <div className={styles.iconWrapper}>
                <div className={styles.iconInner}>
                  <img src={f.icon} alt="" className={`${styles.iconLayer} ${styles.iconBase} ${f.iconClassName} ${f.baseClassName}`} />
                  <img src={f.icon} alt="" className={`${styles.iconLayer} ${styles.iconAccent} ${f.iconClassName} ${f.accentClassName}`} />
                </div>
              </div>
              <span className={styles.featureLabel}>{f.label}</span>
            </div>
          ))}
        </div>

        <p className={styles.subtitle}>{activeFeature !== null ? features[activeFeature].desc : t("hero_swipe_desc")}</p>

        <button className={styles.cta} onClick={startHandler}>
          {t("hero_cta")}
        </button>
      </div>
    </div>
  );
};

export default HeroPage;
